var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRoundPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.41992,
    y: 4,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#49505E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2533 13.1667V9H13.5866V13.1667H9.41992V14.8333H13.5866V19H15.2533V14.8333H19.4199V13.1667H15.2533Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundPlus);
export default __webpack_public_path__ + "static/media/icon-round-plus.4d289cd5d263ad6bb4f2efe61b07bb91.svg";
export { ForwardRef as ReactComponent };